/* Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. */

import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
	EXTERNAL_LINK_MODAL_CONTENT,
	EXTERNAL_LINK_SETTINGS,
	UICONTROL_TEXT_CANCEL,
	UICONTROL_TEXT_SAVE,
} from '@touchplan/strings';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { PlanState } from 'src/app/services/plan-state.service';
import { AllowedLinksEditorComponent } from './allowed-links-editor/allowed-links-editor.component';

@Component({
	selector: 'allowed-links-starter',
	template: '',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AllowedLinksStarterComponent implements OnInit {
	private shutdownSubject$: Subject<boolean> = new Subject();

	constructor(private dialog: MatDialog, private planState: PlanState) {}

	public ngOnInit(): void {
		this.openAllowedLinksDialog();
	}

	public openAllowedLinksDialog(): void {
		const data = {
			title: EXTERNAL_LINK_SETTINGS,
			content: [EXTERNAL_LINK_MODAL_CONTENT],
			dataObservable: this.planState.allowedProjectLinks$,
			width: '350px',
			yesButtonText: UICONTROL_TEXT_SAVE.toUpperCase(),
			noButtonText: UICONTROL_TEXT_CANCEL.toUpperCase(),
		};
		this.dialog
			.open(AllowedLinksEditorComponent, { data, disableClose: true })
			.afterClosed()
			.pipe(distinctUntilChanged(), takeUntil(this.shutdownSubject$))
			.subscribe((saveObj) => {
				if (saveObj) {
					this.planState.saveAllowedLinksString(saveObj.value);
				}
			});
	}
}
